import { useContext, useEffect, useState } from "react";
import { ReactComponent as eventIcon } from '../../../../icons/event.svg';
import 'react-datepicker/dist/react-datepicker.css';
import './../krFormView.scss';
import { DatepickerFieldProps } from "../../../../components/datepickerField/types/datepickerFieldProps";
import DatepickerField from "../../../../components/datepickerField/datepickerField";
import { configValidation, createConfigValidation, validation } from "../../../../helpers/validation/validation";
import KrFormContext, { KrEndangeredAreaFormTypes, krFormTypes, KrLandslideFormTypes, NavHeadingsKROEnum, NavHeadingsKRTZEum } from "../../../../contexts/krFormContext";
import { styleFormFieldHalf } from "../../../../components/shared/stylization";
import { FormSectionProps } from "./shared/types/formSectionProps";
import { ObjectType, PatternType } from "../../../../contexts/types/card";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict, KRTZFieldDict } from "../../shared/commentsSidebar/fieldDict";

const CardCompletionDate = (props: FormSectionProps) => {
    const { krForm, setkrForm, setFillDate } = useContext(KrFormContext);
    const [configValidationDate, setConfigValidationDate] = useState<configValidation>({});
    const [errorTipText, setErrorTipText] = useState<string | null>();
    const [firstRenderMarker, setFirstRenderMarker] = useState(false);
    const [reload, setReload] = useState(false);

    const title = props.version === PatternType.P2007 ? 'Data wypełnienia' : 'Data wypełnienia karty';

    // Validation 
    useEffect(() => {
        if (krForm.config?.check && !krForm.config.isValid) {
            var errorMsg = krForm.config?.ValidationError!["datA_WYPELNIENIA"]
            if (errorMsg !== '') {
                if (props.version === PatternType.P2007) {
                    setErrorTipText(errorMsg);
                    setReload(!reload);
                } else {
                    const determinedDate = getAttributes(krForm)?.datA_USTALENIA;
                    setConfigValidationDate(createConfigValidation("datA_WYPELNIENIA", false, determinedDate, props.version));
                    setErrorTipText(errorMsg);
                }
            }
        }

        if (krForm.config?.check){
            const completeDate = getAttributes(krForm)?.datA_WYPELNIENIA;
            setFillDate(completeDate);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [krForm.config?.check])

    useEffect(() => {
        if (props.version !== PatternType.P2007) {
            if (firstRenderMarker) {
                const determinedDate = getAttributes(krForm)?.datA_USTALENIA;
                const completeDate = getAttributes(krForm)?.datA_WYPELNIENIA;
                var configValidation = createConfigValidation("datA_WYPELNIENIA", false, determinedDate, props.version);
                setFillDate(completeDate);
                setConfigValidationDate(configValidation);
                setErrorTipText(validation(configValidation, completeDate))
                
            }
            if (!firstRenderMarker) setFirstRenderMarker(true);
        }
        // @ts-ignore
        // eslint-disable-next-line react-hooks/exhaustive-deps    
    }, [krForm.landslideAttributes?.datA_USTALENIA, krForm.landslideAttributes?.datA_WYPELNIENIA, krForm.endangeredAreaAttributes?.datA_USTALENIA, krForm.endangeredAreaAttributes?.datA_WYPELNIENIA])

    const onChangeCardCompletionDate = (event: Date) => {
        var form: any = Object.assign({}, krForm);
        const attributes = getAttributes(form);
        if (form !== null && attributes) {
            if(event){
                event.setHours(12, 0, 0, 0);
            }
            event ? attributes.datA_WYPELNIENIA = event.getTime() : attributes.datA_WYPELNIENIA = null;
        }
        setFillDate(attributes?.datA_WYPELNIENIA);
        setkrForm(form);
    }

    const getAttributes = (form: krFormTypes) => {
        return props.objectType === ObjectType.KRO ? (form as KrLandslideFormTypes).landslideAttributes : (form as KrEndangeredAreaFormTypes).endangeredAreaAttributes;
    }

    const getTitle = () => {
        let ordinalNumber = 1;
        switch (props.objectType) {
            case ObjectType.KRTZ:
                ordinalNumber = props.version === PatternType.P2007 ? 7 : 9;
                break;
            case ObjectType.KRO:
                ordinalNumber = props.version === PatternType.P2007 ? 21 : 22;
                break;
            default:
                break;
        }
        return `${ordinalNumber}. ${title}`;
    }

    const prepareSelected = () => {
        const attributes = getAttributes(krForm);
        return attributes?.datA_WYPELNIENIA ? new Date(new Date(attributes?.datA_WYPELNIENIA).setHours(12, 0, 0, 0)) : attributes?.datA_WYPELNIENIA;
    }

    // Card completion date
    const cardCompletionDateKRFieldDict = props.objectType === ObjectType.KRO ? KROFieldDict.dataWyp_dataWypelnieniaKarty : KRTZFieldDict.dataWyp_dataWypelnieniaKarty;
    var datepickerFieldPropsCardCompletionDate: DatepickerFieldProps = {
        dateFormat: "yyyy-MM-dd",
        selected: prepareSelected(),
        shouldCloseOnSelect: false,
        fixedHeight: true,
        inputPlaceholder: "Wybierz datę",
        labelName: title,
        style: styleFormFieldHalf,
        configValidation: props.version === PatternType.P2007 ? createConfigValidation("datA_WYPELNIENIA", false, undefined, props.version) : configValidationDate,
        additionalIcon: eventIcon,
        setValue: onChangeCardCompletionDate,
        datepickerSharedProps: {
            className: 'datepicker'
        },
        validationError: props.version === PatternType.P2007 ? krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false : errorTipText != null,
        tipText: errorTipText ? errorTipText : undefined,
        pristine: true,
        reload: reload,
        disabled: !props.editMode,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, cardCompletionDateKRFieldDict, title, props.setNewCommentFieldDetails!),
        inputRef: (node: any) => {getFieldRef(node, cardCompletionDateKRFieldDict, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(cardCompletionDateKRFieldDict); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === cardCompletionDateKRFieldDict
    }

    return (
        <>
            <h2 ref={(node) => props.objectType === ObjectType.KRO ? getItemRef(node, NavHeadingsKROEnum.CardCompletionDate, props.getMapForNavScroll!) : 
                getItemRef(node, NavHeadingsKRTZEum.CardCompletionDate, props.getMapForNavScroll!)}
                style={{ width: '100%' }}>{getTitle()}</h2>
            <DatepickerField {...datepickerFieldPropsCardCompletionDate} />
        </>
    )
}

export default CardCompletionDate;